export const siteLogo = () => (
  <svg
    width="133"
    height="34"
    viewBox="0 0 133 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M127.179 14.5614C130.173 14.5614 132.599 12.16 132.599 9.1977C132.599 6.2354 130.173 3.83398 127.179 3.83398C124.186 3.83398 121.76 6.2354 121.76 9.1977C121.76 12.16 124.186 14.5614 127.179 14.5614Z"
      fill="currentColor"
    />
    <path
      d="M127.179 29.3114C130.173 29.3114 132.599 26.91 132.599 23.9477C132.599 20.9854 130.173 18.584 127.179 18.584C124.186 18.584 121.76 20.9854 121.76 23.9477C121.76 26.91 124.186 29.3114 127.179 29.3114Z"
      fill="currentColor"
    />
    <path d="M23.6465 33.9826L36.8292 0H23.6465V33.9826Z" fill="currentColor" />
    <path
      d="M66.9961 33.9828H89.5075L92.9849 25.0186H66.9961V33.9828Z"
      fill="currentColor"
    />
    <path d="M66.9961 0V25.0183L76.7014 0H66.9961Z" fill="currentColor" />
    <path d="M0 0L13.1827 33.9826H23.6456L10.4629 0H0Z" fill="currentColor" />
    <path
      d="M105.468 8.98385H112.997L116.503 0H94.6988L94.6855 8.98385H102.226V25.0183H94.6855V34H113.011L116.503 25.0183H105.468V8.98385Z"
      fill="currentColor"
    />
    <path
      d="M61.8279 8.95115L65.2855 0H38.5391V33.9826H61.8081L65.2855 25.0183H41.7786V20.6681H57.2692L60.2159 13.0704H41.7786V8.95115H61.8279Z"
      fill="currentColor"
    />
  </svg>
);
export const arrDownSvg = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 1.5L4.5 4.5L1.5 1.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const arrThickSvg = () => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 2L5.29289 5.29289C5.68342 5.68342 6.31658 5.68342 6.70711 5.29289L10 2"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
    />
  </svg>
);
export const arrLeft = () => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.00016 10.6668L1.3335 6.00016L6.00016 1.3335"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const arrRight = () => (
  <svg
    width="6"
    height="10"
    viewBox="0 0 6 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.999999 1L5 5L1 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const searchStrokeSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.76709 1C9.94701 1 12.5336 3.52952 12.5336 6.63931C12.5336 8.10649 11.9578 9.44464 11.0157 10.4489L12.8696 12.2582C13.0431 12.4278 13.0437 12.7023 12.8702 12.872C12.7837 12.9577 12.6694 13 12.5557 13C12.4426 13 12.3289 12.9577 12.2419 12.8732L10.3656 11.0434C9.37857 11.8164 8.1271 12.2792 6.76709 12.2792C3.58717 12.2792 1 9.74909 1 6.63931C1 3.52952 3.58717 1 6.76709 1ZM6.76709 1.86865C4.07688 1.86865 1.88825 4.00844 1.88825 6.63931C1.88825 9.27017 4.07688 11.4105 6.76709 11.4105C9.4567 11.4105 11.6453 9.27017 11.6453 6.63931C11.6453 4.00844 9.4567 1.86865 6.76709 1.86865Z"
      fill="currentColor"
      stroke="currentColor"
    />
  </svg>
);
export const fbSvg = () => (
  <svg
    width="5"
    height="10"
    viewBox="0 0 5 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.74241 1.799C4.45583 1.74233 4.06878 1.7 3.82535 1.7C3.16621 1.7 3.1234 1.98333 3.1234 2.43667V3.24367H4.77107L4.62745 4.91533H3.1234V10H1.06035V4.91533H0L0 3.24367H1.06035V2.20967C1.06035 0.793333 1.73365 0 3.42414 0C4.01147 0 4.44134 0.0850004 5 0.198334L4.74241 1.799Z"
      fill="currentColor"
    />
  </svg>
);
export const linkedInSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-icon="linkedin-in"
    role="img"
    viewBox="0 0 448 512"
  >
    <path
      fill="currentColor"
      d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
    />
  </svg>
);
export const thumbDown = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6108 4.43801C13.6108 3.72925 13.4793 3.08839 13.2161 2.51543C12.9488 1.93823 12.588 1.47987 12.1339 1.14034C11.6755 0.800812 11.1599 0.631047 10.5869 0.631048L9.55559 0.631048C10.1158 1.10639 10.5423 1.67722 10.8352 2.34355C11.1238 3.00563 11.2596 3.72501 11.2426 4.50168C11.2384 5.0237 11.1875 5.50329 11.0898 5.94043C10.9922 6.38182 10.8585 6.7935 10.6888 7.17547C10.5148 7.55744 10.3089 7.91819 10.0712 8.25772L10.8352 8.25772C11.3615 8.25772 11.8347 8.09007 12.2548 7.75479C12.6708 7.4195 13.0018 6.96114 13.248 6.3797C13.4899 5.8025 13.6108 5.15527 13.6108 4.43801ZM10.2368 4.48895C10.2495 3.84384 10.1328 3.24966 9.88663 2.70642C9.64047 2.16317 9.28609 1.68995 8.82348 1.28676C8.36087 0.883572 7.80914 0.57163 7.16828 0.350936C6.52742 0.125998 5.81653 0.0114066 5.03561 0.00716284L4.13161 0.000797147C3.71994 -0.00344667 3.3507 0.00928492 3.0239 0.0389938C2.69286 0.0644588 2.42548 0.100534 2.22176 0.147219C1.89072 0.227857 1.61486 0.376401 1.39416 0.592851C1.17347 0.805057 1.06312 1.07668 1.06312 1.40772C1.06312 1.52656 1.07585 1.63266 1.10132 1.72603C1.12254 1.81516 1.15225 1.89792 1.19044 1.97431C1.22015 2.02524 1.21379 2.06344 1.17135 2.0889C0.942164 2.21198 0.759667 2.37538 0.623856 2.5791C0.488044 2.77857 0.420138 3.00775 0.420138 3.26664C0.420138 3.55524 0.490167 3.80989 0.630222 4.03058C0.668419 4.08576 0.657809 4.13456 0.598392 4.177C0.445603 4.28735 0.322524 4.43589 0.229154 4.62264C0.131539 4.81362 0.0827314 5.0237 0.0827314 5.25289C0.0827315 5.41841 0.106075 5.57756 0.15276 5.73035C0.199445 5.88314 0.263107 6.00834 0.343745 6.10595C0.39043 6.15688 0.386186 6.20569 0.331012 6.25237C0.224909 6.34999 0.144272 6.47943 0.0890983 6.64071C0.0296806 6.80623 -2.82702e-05 6.98024 -2.82543e-05 7.16274C-2.82213e-05 7.54046 0.129417 7.85877 0.388308 8.11766C0.647199 8.37655 0.963385 8.506 1.33687 8.506L3.68598 8.506C3.94063 8.506 4.1401 8.56329 4.2844 8.67788C4.4287 8.79248 4.50085 8.94314 4.50085 9.12988C4.50085 9.34209 4.44568 9.59461 4.33533 9.88746C4.22074 10.1845 4.08917 10.5029 3.94063 10.8424C3.79209 11.1819 3.66264 11.5236 3.55229 11.8673C3.4377 12.2111 3.38041 12.5358 3.38041 12.8414C3.38041 13.1894 3.48439 13.4695 3.69235 13.6817C3.90031 13.8939 4.16345 14 4.48175 14C4.73216 14 4.94224 13.9236 5.11201 13.7708C5.28177 13.618 5.44729 13.3867 5.60857 13.0769C6.10088 12.122 6.64837 11.2498 7.25104 10.4604C7.84946 9.67101 8.40331 8.94102 8.91261 8.27045C9.21818 7.86301 9.46646 7.46831 9.65745 7.08634C9.84843 6.70437 9.99273 6.3033 10.0903 5.88314C10.1837 5.46721 10.2325 5.00248 10.2368 4.48895Z"
      fill="currentColor"
    />
  </svg>
);

export const thumbUp = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 9.56199C0 10.2708 0.131567 10.9116 0.394702 11.4846C0.662081 12.0618 1.02283 12.5201 1.47695 12.8597C1.93532 13.1992 2.45097 13.369 3.02393 13.369H4.05525C3.49503 12.8936 3.06849 12.3228 2.77565 11.6565C2.48705 10.9944 2.35124 10.275 2.36821 9.49832C2.37246 8.9763 2.42339 8.49671 2.521 8.05957C2.61862 7.61818 2.75231 7.2065 2.92207 6.82453C3.09608 6.44256 3.30192 6.08181 3.53959 5.74228H2.77565C2.24938 5.74228 1.77616 5.90993 1.35599 6.24521C0.940071 6.5805 0.60903 7.03886 0.362872 7.6203C0.120957 8.1975 0 8.84473 0 9.56199ZM3.37407 9.51105C3.36134 10.1562 3.47805 10.7503 3.72421 11.2936C3.97037 11.8368 4.32475 12.31 4.78736 12.7132C5.24997 13.1164 5.8017 13.4284 6.44256 13.6491C7.08342 13.874 7.79431 13.9886 8.57523 13.9928L9.47922 13.9992C9.8909 14.0034 10.2601 13.9907 10.5869 13.961C10.918 13.9355 11.1854 13.8995 11.3891 13.8528C11.7201 13.7721 11.996 13.6236 12.2167 13.4072C12.4374 13.1949 12.5477 12.9233 12.5477 12.5923C12.5477 12.4734 12.535 12.3673 12.5095 12.274C12.4883 12.1848 12.4586 12.1021 12.4204 12.0257C12.3907 11.9748 12.3971 11.9366 12.4395 11.9111C12.6687 11.788 12.8512 11.6246 12.987 11.4209C13.1228 11.2214 13.1907 10.9923 13.1907 10.7334C13.1907 10.4448 13.1207 10.1901 12.9806 9.96942C12.9424 9.91425 12.953 9.86544 13.0124 9.823C13.1652 9.71265 13.2883 9.56411 13.3817 9.37737C13.4793 9.18638 13.5281 8.9763 13.5281 8.74712C13.5281 8.58159 13.5048 8.42244 13.4581 8.26965C13.4114 8.11686 13.3477 7.99166 13.2671 7.89405C13.2204 7.84312 13.2247 7.79431 13.2798 7.74763C13.3859 7.65001 13.4666 7.52057 13.5217 7.35929C13.5812 7.19377 13.6109 7.01976 13.6109 6.83726C13.6109 6.45954 13.4814 6.14123 13.2225 5.88234C12.9636 5.62345 12.6475 5.494 12.274 5.494H9.92486C9.67021 5.494 9.47074 5.43671 9.32644 5.32212C9.18214 5.20753 9.10999 5.05686 9.10999 4.87012C9.10999 4.65791 9.16516 4.40539 9.27551 4.11254C9.3901 3.81546 9.52167 3.49715 9.67021 3.15762C9.81875 2.81809 9.9482 2.47644 10.0585 2.13267C10.1731 1.78889 10.2304 1.46422 10.2304 1.15864C10.2304 0.810625 10.1265 0.530514 9.91849 0.318308C9.71053 0.106103 9.44739 0 9.12909 0C8.87868 0 8.6686 0.076394 8.49883 0.229182C8.32907 0.38197 8.16355 0.613274 8.00227 0.923094C7.50996 1.87802 6.96247 2.75018 6.3598 3.53959C5.76138 4.32899 5.20753 5.05898 4.69823 5.72955C4.39266 6.13699 4.14438 6.53169 3.95339 6.91366C3.76241 7.29563 3.61811 7.6967 3.52049 8.11686C3.42712 8.53279 3.37831 8.99752 3.37407 9.51105Z"
      fill="currentColor"
    />
  </svg>
);
export const cartFillSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.95153 11.6052C4.50443 11.6052 4.95741 12.0679 4.95741 12.6394C4.95741 13.204 4.50443 13.6667 3.95153 13.6667C3.39196 13.6667 2.93898 13.204 2.93898 12.6394C2.93898 12.0679 3.39196 11.6052 3.95153 11.6052ZM11.4457 11.6052C11.9986 11.6052 12.4516 12.0679 12.4516 12.6394C12.4516 13.204 11.9986 13.6667 11.4457 13.6667C10.8861 13.6667 10.4331 13.204 10.4331 12.6394C10.4331 12.0679 10.8861 11.6052 11.4457 11.6052ZM0.852802 0.333423L0.920689 0.339169L2.50945 0.583411C2.73594 0.624912 2.90248 0.814726 2.92246 1.04604L3.04903 2.57C3.06901 2.78839 3.24221 2.95167 3.45538 2.95167H12.4517C12.8581 2.95167 13.1245 3.09454 13.391 3.4075C13.6574 3.72046 13.7041 4.16948 13.6441 4.577L13.0113 9.04003C12.8914 9.89794 12.1719 10.53 11.3259 10.53H4.05824C3.17227 10.53 2.4395 9.83671 2.36623 8.93866L1.75337 1.52228L0.74749 1.34539C0.481031 1.29777 0.29451 1.03243 0.34114 0.760299C0.387771 0.48204 0.647568 0.297668 0.920689 0.339169L0.852802 0.333423ZM10.2601 5.46825H8.41485C8.13507 5.46825 7.91524 5.69276 7.91524 5.9785C7.91524 6.25744 8.13507 6.48876 8.41485 6.48876H10.2601C10.5399 6.48876 10.7597 6.25744 10.7597 5.9785C10.7597 5.69276 10.5399 5.46825 10.2601 5.46825Z"
      fill="currentColor"
    />
  </svg>
);
export const cartStroke = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.07948 21.2695C10.0765 21.2695 10.8943 22.1097 10.8943 23.1404C10.8943 24.1599 10.0765 25.0001 9.07948 25.0001C8.07122 25.0001 7.25342 24.1599 7.25342 23.1404C7.25342 22.1097 8.07122 21.2695 9.07948 21.2695Z"
      fill="currentColor"
    />
    <path
      d="M19.8118 21.2695C20.8088 21.2695 21.6266 22.1097 21.6266 23.1404C21.6266 24.1599 20.8088 25.0001 19.8118 25.0001C18.8035 25.0001 17.9857 24.1599 17.9857 23.1404C17.9745 22.1097 18.7923 21.2695 19.8118 21.2695Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.0191 1.23249C0.123651 0.73826 0.628333 0.41847 1.14634 0.518224C2.36296 0.752513 3.84947 1.0084 4.37886 1.09258L4.3858 1.09369L4.39272 1.09489C4.89383 1.18182 5.36365 1.58714 5.39103 2.16526L5.60699 4.53858H21.8275C22.3217 4.53858 22.7803 4.62587 23.2098 4.83181C23.6321 5.03433 23.9698 5.32461 24.264 5.65104L24.2671 5.65442L24.2701 5.65783C25.0031 6.48736 25.0791 7.56999 24.9469 8.40842L23.7998 16.1339C23.7997 16.1345 23.7996 16.1352 23.7995 16.1359C23.5205 18.0621 21.8053 19.5 19.79 19.5H8.74687C6.61869 19.5 4.89561 17.9134 4.7203 15.904C4.72024 15.9034 4.72018 15.9027 4.72013 15.9021L3.52836 2.80503C2.81439 2.68424 1.71226 2.4899 0.767724 2.30801C0.249719 2.20825 -0.0854515 1.72673 0.0191 1.23249ZM5.77313 6.36445L6.62714 15.7496L6.6273 15.7515C6.7231 16.8559 7.65624 17.6741 8.74687 17.6741H19.79C20.8358 17.6741 21.7543 16.9219 21.904 15.8848L21.9042 15.8831L23.0534 8.14384L23.0541 8.13949C23.1456 7.563 23.0415 7.10275 22.8097 6.83779C22.6215 6.6297 22.4761 6.52351 22.3505 6.46325C22.2312 6.40605 22.0762 6.36445 21.8275 6.36445H5.77313Z"
      fill="currentColor"
    />
    <path
      d="M18.0018 11.5H12.9982C12.4437 11.5 12 11.0488 12 10.5C12 9.93902 12.4437 9.5 12.9982 9.5H18.0018C18.5563 9.5 19 9.93902 19 10.5C19 11.0488 18.5563 11.5 18.0018 11.5Z"
      fill="currentColor"
    />
    <path
      d="M18.0471 15.5H15.9529C15.4235 15.5 15 15.0488 15 14.5C15 13.939 15.4235 13.5 15.9529 13.5H18.0471C18.5765 13.5 19 13.939 19 14.5C19 15.0488 18.5765 15.5 18.0471 15.5Z"
      fill="currentColor"
    />
  </svg>
);
export const box3DSvg = () => (
  <svg
    width="20"
    height="23"
    viewBox="0 0 20 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19 15V7.00002C18.9996 6.6493 18.9071 6.30483 18.7315 6.00119C18.556 5.69754 18.3037 5.44539 18 5.27002L11 1.27002C10.696 1.09449 10.3511 1.00208 10 1.00208C9.64893 1.00208 9.30404 1.09449 9 1.27002L2 5.27002C1.69626 5.44539 1.44398 5.69754 1.26846 6.00119C1.09294 6.30483 1.00036 6.6493 1 7.00002V15C1.00036 15.3508 1.09294 15.6952 1.26846 15.9989C1.44398 16.3025 1.69626 16.5547 2 16.73L9 20.73C9.30404 20.9056 9.64893 20.998 10 20.998C10.3511 20.998 10.696 20.9056 11 20.73L18 16.73C18.3037 16.5547 18.556 16.3025 18.7315 15.9989C18.9071 15.6952 18.9996 15.3508 19 15Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.26953 5.95996L9.99953 11.01L18.7295 5.95996"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 21.08V11"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const brandLogo = () => (
  <svg
    width="118"
    height="32"
    viewBox="0 0 118 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.4282 31.253L33.1417 0.745117H21.4282V31.253Z"
      fill="currentColor"
    />
    <path
      d="M59.9448 31.2531H79.9507L83.0394 23.2061H59.9448V31.2531Z"
      fill="currentColor"
    />
    <path
      d="M100.836 8.8101L103.932 0.745117H84.5545L84.5474 8.8101H91.2441V23.2059H84.5474V31.253H100.832L103.921 23.2059H94.1244V8.8101H100.836Z"
      fill="currentColor"
    />
    <path
      d="M55.3473 8.77596L58.4289 0.745117H34.6587V31.253H55.3384L58.4289 23.2059H37.539V19.301H51.3081L53.9261 12.4796H37.539V8.77596H55.3473Z"
      fill="currentColor"
    />
    <path
      d="M59.9448 0.745117V23.2059L68.5642 0.745117H59.9448Z"
      fill="currentColor"
    />
    <path
      d="M0.42334 0.745117L12.1297 31.253H21.4282L9.71293 0.745117H0.42334Z"
      fill="currentColor"
    />
    <path
      d="M117.868 22.7775C117.868 23.6959 117.595 24.5937 117.085 25.3573C116.575 26.1209 115.85 26.7161 115.001 27.0675C114.153 27.419 113.219 27.5109 112.319 27.3317C111.418 27.1526 110.591 26.7103 109.941 26.0609C109.292 25.4115 108.85 24.5841 108.671 23.6834C108.492 22.7826 108.584 21.849 108.935 21.0005C109.286 20.152 109.881 19.4268 110.645 18.9166C111.409 18.4064 112.306 18.134 113.225 18.134C114.456 18.134 115.637 18.6233 116.508 19.4941C117.378 20.3649 117.868 21.546 117.868 22.7775"
      fill="currentColor"
    />
    <path
      d="M117.868 9.97282C117.868 10.8912 117.595 11.789 117.085 12.5526C116.575 13.3162 115.85 13.9114 115.001 14.2628C114.153 14.6143 113.219 14.7062 112.319 14.5271C111.418 14.3479 110.591 13.9056 109.941 13.2562C109.292 12.6068 108.85 11.7795 108.671 10.8787C108.492 9.97796 108.584 9.04432 108.935 8.19584C109.286 7.34736 109.881 6.62214 110.645 6.11191C111.409 5.60168 112.306 5.32935 113.225 5.32935C114.456 5.32935 115.637 5.81857 116.508 6.68939C117.378 7.56021 117.868 8.7413 117.868 9.97282"
      fill="currentColor"
    />
  </svg>
);
export const brandLogoSm = () => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.0049 31.6546L32.7184 0.958984H21.0049V31.6546Z"
      fill="currentColor"
    />
    <path
      d="M0 0.958984L11.7063 31.6546H21.0049L9.28959 0.958984H0Z"
      fill="currentColor"
    />
    <path
      d="M45.8627 23.1274C45.8627 24.0514 45.5904 24.9547 45.0802 25.723C44.57 26.4914 43.8449 27.0902 42.9965 27.4438C42.1481 27.7974 41.2145 27.8899 40.3139 27.7097C39.4132 27.5294 38.5859 27.0844 37.9366 26.431C37.2872 25.7776 36.845 24.9451 36.6659 24.0388C36.4867 23.1326 36.5787 22.1932 36.9301 21.3395C37.2815 20.4858 37.8766 19.7561 38.6401 19.2427C39.4037 18.7293 40.3014 18.4553 41.2197 18.4553C42.4511 18.4553 43.632 18.9476 44.5028 19.8237C45.3735 20.6999 45.8627 21.8883 45.8627 23.1274Z"
      fill="currentColor"
    />
    <path
      d="M45.8627 10.2434C45.8627 11.1674 45.5904 12.0707 45.0802 12.839C44.57 13.6073 43.8449 14.2062 42.9965 14.5598C42.1481 14.9134 41.2145 15.0059 40.3139 14.8256C39.4132 14.6454 38.5859 14.2004 37.9366 13.547C37.2872 12.8936 36.845 12.0611 36.6659 11.1548C36.4867 10.2485 36.5787 9.30914 36.9301 8.45543C37.2815 7.60172 37.8766 6.87204 38.6401 6.35867C39.4037 5.8453 40.3014 5.57129 41.2197 5.57129C42.4511 5.57129 43.632 6.06352 44.5028 6.9397C45.3735 7.81588 45.8627 9.00424 45.8627 10.2434Z"
      fill="currentColor"
    />
  </svg>
);
export const menuBurger = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="2.2 2.5 11.5 11"
  >
    <path
      fillRule="evenodd"
      d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
    />
  </svg>
);
export const zoomSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.91675 7.25945C1.91675 4.40085 4.2341 2.0835 7.09271 2.0835C9.95131 2.0835 12.2687 4.40085 12.2687 7.25945C12.2687 8.65344 11.7176 9.91872 10.8214 10.8493C10.7957 10.8691 10.771 10.8907 10.7475 10.9143C10.724 10.9378 10.7023 10.9625 10.6826 10.9882C9.75197 11.8843 8.48669 12.4354 7.09271 12.4354C4.2341 12.4354 1.91675 10.1181 1.91675 7.25945ZM11.2533 12.4807C10.1122 13.3912 8.66601 13.9354 7.09271 13.9354C3.40568 13.9354 0.416748 10.9465 0.416748 7.25945C0.416748 3.57242 3.40568 0.583496 7.09271 0.583496C10.7797 0.583496 13.7687 3.57242 13.7687 7.25945C13.7687 8.83276 13.2244 10.2789 12.3139 11.42L15.0304 14.1365C15.3233 14.4294 15.3233 14.9043 15.0304 15.1972C14.7375 15.49 14.2626 15.49 13.9697 15.1972L11.2533 12.4807Z"
      fill="currentColor"
    />
  </svg>
);
export const arrowHorizontal = () => (
  <svg
    width="9"
    height="6"
    viewBox="0 0 9 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 1.25L4.5 4.75L1 1.25"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const timeStroke = () => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="8.5" cy="9" r="7.65" stroke="currentColor" strokeWidth="1.7" />
    <path
      d="M8.5 5V9.4C8.5 9.45523 8.54477 9.5 8.6 9.5H11.5"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
  </svg>
);
export const filterLines = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7C21 7.55228 20.5523 8 20 8H4C3.44772 8 3 7.55228 3 7ZM6 12C6 11.4477 6.44772 11 7 11H17C17.5523 11 18 11.4477 18 12C18 12.5523 17.5523 13 17 13H7C6.44772 13 6 12.5523 6 12ZM9 17C9 16.4477 9.44772 16 10 16H14C14.5523 16 15 16.4477 15 17C15 17.5523 14.5523 18 14 18H10C9.44772 18 9 17.5523 9 17Z"
      fill="currentColor"
    />
  </svg>
);
export const errorSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="12.5" cy="12" r="12" fill="#EA5651" />
    <circle
      cx="12.4381"
      cy="16.8601"
      r="1.14"
      transform="rotate(-180 12.4381 16.8601)"
      fill="white"
    />
    <path
      d="M12.457 14.8488C11.9494 14.8488 11.5333 14.4462 11.5168 13.9388L11.3342 8.34286C11.3138 7.71784 11.8149 7.20007 12.4403 7.20007C13.063 7.20007 13.5632 7.71373 13.5466 8.33627L13.3973 13.9332C13.3837 14.4428 12.9667 14.8488 12.457 14.8488Z"
      fill="white"
    />
  </svg>
);
export const userFill = () => (
  <svg
    width="13"
    height="16"
    viewBox="0 0 13 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.48718 10.1C10.0048 10.1 12.9744 10.64 12.9744 12.7257C12.9744 14.8113 9.98574 15.3333 6.48718 15.3333C2.96957 15.3333 0 14.7925 0 12.7077C0 10.622 2.98776 10.1 6.48718 10.1ZM6.48718 0C8.86977 0 10.7796 1.805 10.7796 4.05675C10.7796 6.3085 8.86977 8.1135 6.48718 8.1135C4.10459 8.1135 2.19472 6.3085 2.19472 4.05675C2.19472 1.805 4.10459 0 6.48718 0Z"
      fill="currentColor"
    />
  </svg>
);
export const chatSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.99903 0C12.4169 0 15.9981 3.58116 15.9981 7.99902C15.9981 12.4169 12.4169 15.998 7.99903 15.998C6.70497 15.9998 5.42997 15.6862 4.28428 15.0846L0.852703 15.9781C0.738042 16.0079 0.617567 16.0073 0.503218 15.9763C0.38887 15.9452 0.284618 15.8848 0.200795 15.8011C0.116972 15.7173 0.0564878 15.6132 0.0253375 15.4988C-0.00581286 15.3845 -0.00654805 15.264 0.0232047 15.1494L0.915896 11.7186C0.312609 10.5717 -0.00177551 9.29491 7.54233e-06 7.99902C7.54233e-06 3.58116 3.58117 0 7.99903 0ZM9.00051 8.79893H5.39935L5.31776 8.80453C5.17417 8.82428 5.04258 8.89536 4.94733 9.00461C4.85208 9.11386 4.79961 9.25391 4.79961 9.39885C4.79961 9.5438 4.85208 9.68384 4.94733 9.79309C5.04258 9.90235 5.17417 9.97342 5.31776 9.99318L5.39935 9.99878H9.00051L9.0813 9.99318C9.22489 9.97342 9.35647 9.90235 9.45173 9.79309C9.54698 9.68384 9.59945 9.5438 9.59945 9.39885C9.59945 9.25391 9.54698 9.11386 9.45173 9.00461C9.35647 8.89536 9.22489 8.82428 9.0813 8.80453L9.00051 8.79893ZM10.5987 5.99927H5.39935L5.31776 6.00487C5.17417 6.02462 5.04258 6.0957 4.94733 6.20495C4.85208 6.31421 4.79961 6.45425 4.79961 6.59919C4.79961 6.74414 4.85208 6.88418 4.94733 6.99344C5.04258 7.10269 5.17417 7.17377 5.31776 7.19352L5.39935 7.19912H10.5987L10.6803 7.19352C10.8239 7.17377 10.9555 7.10269 11.0507 6.99344C11.146 6.88418 11.1985 6.74414 11.1985 6.59919C11.1985 6.45425 11.146 6.31421 11.0507 6.20495C10.9555 6.0957 10.8239 6.02462 10.6803 6.00487L10.5987 5.99927Z"
      fill="currentColor"
    ></path>
  </svg>
);
export const settingsSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="black"
      strokeWidth="1.71591"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15V15Z"
      stroke="black"
      strokeWidth="1.71591"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const exitSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.5 16.3613H3.16667C2.72464 16.3613 2.30072 16.1857 1.98816 15.8732C1.67559 15.5606 1.5 15.1367 1.5 14.6947V3.02799C1.5 2.58597 1.67559 2.16204 1.98816 1.84948C2.30072 1.53692 2.72464 1.36133 3.16667 1.36133H6.5"
      stroke="currentColor"
      strokeWidth="1.71591"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M12.334 13.0296L16.5007 8.86296L12.334 4.69629"
      stroke="currentColor"
      strokeWidth="1.71591"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
    <path
      d="M16.5 8.8623H6.5"
      stroke="currentColor"
      strokeWidth="1.71591"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></path>
  </svg>
);
export const closeSvg = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1L1 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1 1L9 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const linkArrowRight = () => (
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.333008 6.43848C0.333008 6.12207 0.568136 5.86058 0.873199 5.81919L0.958008 5.81348L11.9447 5.81398L7.97552 1.86104C7.73092 1.61749 7.73006 1.22176 7.97362 0.977161C8.19503 0.754795 8.5422 0.733875 8.78727 0.914893L8.8575 0.975258L13.8992 5.99526C13.9314 6.02736 13.9594 6.06211 13.9832 6.0988C13.9899 6.10984 13.9967 6.12114 14.0032 6.13267C14.0092 6.14255 14.0145 6.15281 14.0196 6.16318C14.0267 6.17827 14.0336 6.19386 14.0398 6.20977C14.0449 6.22204 14.0492 6.23397 14.053 6.24599C14.0576 6.2609 14.0621 6.27679 14.066 6.29293C14.0688 6.30419 14.0711 6.31503 14.0731 6.32591C14.0759 6.34211 14.0782 6.35886 14.0799 6.37582C14.0814 6.38875 14.0822 6.40156 14.0827 6.41439C14.0828 6.42216 14.083 6.43031 14.083 6.43848L14.0827 6.4627C14.0822 6.47496 14.0814 6.48722 14.0802 6.49944L14.083 6.43848C14.083 6.47792 14.0794 6.51651 14.0724 6.55393C14.0707 6.56286 14.0688 6.57204 14.0667 6.58117C14.0622 6.59999 14.0571 6.6181 14.0512 6.63587C14.0483 6.64469 14.0449 6.65412 14.0413 6.66348C14.034 6.68228 14.0261 6.70021 14.0173 6.71767C14.0133 6.72589 14.0087 6.73448 14.004 6.74299C13.9962 6.75687 13.9881 6.77006 13.9796 6.78292C13.9736 6.79202 13.967 6.8015 13.96 6.81082L13.9546 6.81802C13.9378 6.84002 13.9195 6.86087 13.9 6.88043L13.8992 6.88101L8.85753 11.9018C8.61295 12.1454 8.21722 12.1446 7.97365 11.9C7.75222 11.6777 7.73277 11.3304 7.91482 11.0861L7.97548 11.0161L11.943 7.06398L0.958008 7.06348C0.61283 7.06348 0.333008 6.78366 0.333008 6.43848Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);
export const linkArrowLeft = () => (
  <svg
    width="15"
    height="13"
    viewBox="0 0 15 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6641 6.56152C14.6641 6.87793 14.4289 7.13942 14.1239 7.18081L14.0391 7.18652L3.0524 7.18602L7.02155 11.139C7.26616 11.3825 7.26701 11.7782 7.02346 12.0228C6.80205 12.2452 6.45487 12.2661 6.2098 12.0851L6.13957 12.0247L1.09791 7.00474C1.06567 6.97264 1.03766 6.93789 1.01389 6.9012C1.00718 6.89016 1.00035 6.87886 0.993866 6.86733C0.987908 6.85745 0.982523 6.84719 0.977443 6.83682C0.970387 6.82173 0.963494 6.80614 0.957235 6.79023C0.952149 6.77796 0.947902 6.76603 0.944029 6.75401C0.939425 6.7391 0.93495 6.72321 0.931102 6.70708C0.928241 6.69581 0.925975 6.68497 0.923999 6.67409C0.921219 6.6579 0.918854 6.64114 0.917166 6.62418C0.915708 6.61125 0.914831 6.59844 0.914346 6.58561C0.914221 6.57784 0.914063 6.5697 0.914063 6.56152L0.914377 6.53731C0.914855 6.52504 0.915693 6.51278 0.916891 6.50056L0.914063 6.56152C0.914063 6.52208 0.917717 6.48349 0.924703 6.44608C0.926323 6.43714 0.928254 6.42797 0.930392 6.41883C0.934831 6.40002 0.939962 6.3819 0.94587 6.36414C0.94877 6.35531 0.952148 6.34588 0.955758 6.33652C0.963062 6.31772 0.971 6.29979 0.979733 6.28233C0.983791 6.27412 0.988334 6.26552 0.993093 6.25701C1.0009 6.24313 1.00895 6.22994 1.01746 6.21708C1.02346 6.20798 1.03011 6.19851 1.03705 6.18918L1.04246 6.18198C1.0593 6.15998 1.07756 6.13913 1.09712 6.11958L1.09787 6.11899L6.13954 1.09816C6.38412 0.854589 6.77985 0.855408 7.02342 1.09999C7.24485 1.32234 7.2643 1.6696 7.08225 1.9139L7.02159 1.98387L3.05406 5.93602L14.0391 5.93652C14.3842 5.93652 14.6641 6.21634 14.6641 6.56152Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);
export const eyeSvg = () => (
  <svg
    width="16"
    height="13"
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.666992 6.81966C0.666992 6.81966 3.33366 1.48633 8.00033 1.48633C12.667 1.48633 15.3337 6.81966 15.3337 6.81966C15.3337 6.81966 12.667 12.153 8.00033 12.153C3.33366 12.153 0.666992 6.81966 0.666992 6.81966Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 8.81982C9.10457 8.81982 10 7.92439 10 6.81982C10 5.71525 9.10457 4.81982 8 4.81982C6.89543 4.81982 6 5.71525 6 6.81982C6 7.92439 6.89543 8.81982 8 8.81982Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const eyeCloseSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.41366 9.41319C9.23056 9.60969 9.00976 9.76729 8.76443 9.8766C8.5191 9.98591 8.25426 10.0447 7.98572 10.0494C7.71718 10.0542 7.45043 10.0048 7.2014 9.90418C6.95236 9.80359 6.72614 9.65387 6.53622 9.46396C6.34631 9.27404 6.19659 9.04782 6.096 8.79878C5.99541 8.54975 5.94601 8.283 5.95075 8.01446C5.95549 7.74592 6.01426 7.48108 6.12358 7.23575C6.23289 6.99042 6.39049 6.76962 6.58699 6.58652M11.9603 11.9599C10.8207 12.8285 9.43306 13.3098 8.00033 13.3332C3.33366 13.3332 0.666992 7.99985 0.666992 7.99985C1.49625 6.45445 2.64642 5.10426 4.04033 4.03985L11.9603 11.9599ZM6.60032 2.82652C7.05921 2.71911 7.52903 2.66541 8.00033 2.66652C12.667 2.66652 15.3337 7.99985 15.3337 7.99985C14.929 8.75693 14.4464 9.46968 13.8937 10.1265L6.60032 2.82652Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.666992 0.666504L15.3337 15.3332"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const instagramSvg = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.00001 2.08108C8.60207 2.08108 8.79184 2.0872 9.42451 2.11607C10.0095 2.14274 10.3272 2.24049 10.5386 2.32266C10.8187 2.4315 11.0186 2.56152 11.2285 2.77146C11.4385 2.98143 11.5685 3.18131 11.6773 3.46137C11.7595 3.6728 11.8573 3.99049 11.8839 4.57549C11.9128 5.20816 11.9189 5.39794 11.9189 6.99999C11.9189 8.60207 11.9128 8.79184 11.8839 9.42452C11.8573 10.0095 11.7595 10.3272 11.6773 10.5386C11.5685 10.8187 11.4385 11.0186 11.2285 11.2285C11.0186 11.4385 10.8187 11.5685 10.5386 11.6773C10.3272 11.7595 10.0095 11.8573 9.42451 11.8839C8.79193 11.9128 8.60218 11.9189 7.00001 11.9189C5.39782 11.9189 5.20809 11.9128 4.57549 11.8839C3.99049 11.8573 3.6728 11.7595 3.46137 11.6773C3.18131 11.5685 2.98143 11.4385 2.77149 11.2285C2.56154 11.0186 2.4315 10.8187 2.32266 10.5386C2.24049 10.3272 2.14274 10.0095 2.11607 9.42452C2.0872 8.79184 2.08108 8.60207 2.08108 6.99999C2.08108 5.39794 2.0872 5.20816 2.11607 4.57549C2.14274 3.99049 2.24049 3.6728 2.32266 3.46137C2.4315 3.18131 2.56152 2.98143 2.77149 2.77149C2.98143 2.56152 3.18131 2.4315 3.46137 2.32266C3.6728 2.24049 3.99049 2.14274 4.57549 2.11607C5.20816 2.0872 5.39794 2.08108 7.00001 2.08108ZM7.00001 1C5.3705 1 5.16617 1.00691 4.52621 1.03611C3.88758 1.06523 3.45142 1.16667 3.06977 1.31498C2.67522 1.46831 2.34061 1.67347 2.00703 2.00703C1.67347 2.34061 1.46831 2.67522 1.315 3.06977C1.16667 3.45142 1.06523 3.88758 1.03611 4.52621C1.00691 5.16617 1 5.3705 1 6.99999C1 8.6295 1.00691 8.83383 1.03611 9.47379C1.06523 10.1124 1.16667 10.5486 1.315 10.9302C1.46831 11.3248 1.67347 11.6594 2.00703 11.993C2.34061 12.3265 2.67522 12.5317 3.06977 12.685C3.45142 12.8333 3.88758 12.9348 4.52621 12.9639C5.16617 12.9931 5.3705 13 7.00001 13C8.6295 13 8.83383 12.9931 9.47379 12.9639C10.1124 12.9348 10.5486 12.8333 10.9302 12.685C11.3248 12.5317 11.6594 12.3265 11.993 11.993C12.3265 11.6594 12.5317 11.3248 12.685 10.9302C12.8333 10.5486 12.9348 10.1124 12.9639 9.47379C12.9931 8.83383 13 8.6295 13 6.99999C13 5.3705 12.9931 5.16617 12.9639 4.52621C12.9348 3.88758 12.8333 3.45142 12.685 3.06977C12.5317 2.67522 12.3265 2.34061 11.993 2.00703C11.6594 1.67347 11.3248 1.46831 10.9302 1.31498C10.5486 1.16667 10.1124 1.06523 9.47379 1.03611C8.83383 1.00691 8.6295 1 7.00001 1Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M7.00001 5C5.89542 5 5 5.89542 5 6.99999C5 8.10458 5.89542 9 7.00001 9C8.10458 9 9 8.10458 9 6.99999C9 5.89542 8.10458 5 7.00001 5ZM7.00001 8.29825C6.28299 8.29825 5.70175 7.717 5.70175 6.99999C5.70175 6.28299 6.28299 5.70175 7.00001 5.70175C7.717 5.70175 8.29825 6.28299 8.29825 6.99999C8.29825 7.717 7.717 8.29825 7.00001 8.29825Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
    <path
      d="M10 4.50001C10 4.77614 9.77614 5 9.49999 5C9.22386 5 9 4.77614 9 4.50001C9 4.22386 9.22386 4 9.49999 4C9.77614 4 10 4.22386 10 4.50001Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.5"
    />
  </svg>
);
export const youtubeSvg = () => (
  <svg
    width="10"
    height="7"
    viewBox="0 0 10 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.45478 0.535916C9.61006 0.691121 9.72195 0.884278 9.77931 1.09615C10.1096 2.425 10.0333 4.52372 9.78573 5.90384C9.72837 6.11572 9.61648 6.30888 9.46119 6.46408C9.30591 6.61929 9.11266 6.73113 8.90068 6.78846C8.12467 7 5.00135 7 5.00135 7C5.00135 7 1.87804 7 1.10203 6.78846C0.890049 6.73113 0.696796 6.61929 0.541515 6.46408C0.386234 6.30888 0.274341 6.11572 0.216981 5.90384C-0.115232 4.58077 -0.0241617 2.48077 0.210568 1.10256C0.267928 0.890691 0.37982 0.69753 0.535102 0.542325C0.690383 0.387119 0.883635 0.27528 1.09561 0.21795C1.87163 0.00640869 4.99494 0 4.99494 0C4.99494 0 8.11825 0 8.89427 0.211538C9.10625 0.268872 9.2995 0.380711 9.45478 0.535916ZM6.59187 3.5L4.00087 5V2L6.59187 3.5Z"
      fill="currentColor"
    />
  </svg>
);
export const phoneSvg = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.60978 9.04616C10.934 12.3695 11.6881 8.52477 13.8047 10.6398C15.8452 12.6798 17.018 13.0885 14.4327 15.6731C14.1089 15.9334 12.0513 19.0644 4.8205 11.8356C-2.41124 4.60584 0.717982 2.54621 0.978303 2.22246C3.56988 -0.369289 3.97155 0.810326 6.01207 2.85028C8.12863 4.96625 4.28554 5.72285 7.60978 9.04616Z"
      fill="currentColor"
    />
  </svg>
);

export const mailSvg = () => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.0766 0.152344C14.1941 0.152344 15.2691 0.59401 16.0599 1.38651C16.8516 2.17734 17.2941 3.24401 17.2941 4.36068V10.944C17.2941 13.269 15.4024 15.1523 13.0766 15.1523H4.84411C2.51827 15.1523 0.627441 13.269 0.627441 10.944V4.36068C0.627441 2.03568 2.50994 0.152344 4.84411 0.152344H13.0766ZM14.0191 4.48568C13.8441 4.47651 13.6774 4.53568 13.5516 4.65234L9.79411 7.65234C9.31077 8.05318 8.61827 8.05318 8.12744 7.65234L4.37744 4.65234C4.11827 4.46068 3.75994 4.48568 3.54411 4.71068C3.31911 4.93568 3.29411 5.29401 3.48494 5.54401L3.59411 5.65234L7.38577 8.61068C7.85244 8.97734 8.41827 9.17734 9.01077 9.17734C9.60161 9.17734 10.1774 8.97734 10.6433 8.61068L14.4024 5.60234L14.4691 5.53568C14.6683 5.29401 14.6683 4.94401 14.4599 4.70234C14.3441 4.57818 14.1849 4.50234 14.0191 4.48568Z"
      fill="currentColor"
    />
  </svg>
);
export const shareSvg = () => (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.73643 1.74684C8.5233 0.98686 9.57718 0.566336 10.6711 0.575841C11.765 0.585347 12.8114 1.02412 13.585 1.79766C14.3585 2.57121 14.7973 3.61762 14.8068 4.71154C14.8163 5.80545 14.3958 6.85933 13.6358 7.6462L13.6248 7.6574L11.6637 9.61844C11.2408 10.0415 10.7318 10.3687 10.1712 10.5778C9.61072 10.7869 9.01178 10.873 8.41505 10.8303C7.81832 10.7876 7.23775 10.617 6.71274 10.3301C6.18773 10.0433 5.73055 9.64692 5.3722 9.16785C5.07332 8.76827 5.15494 8.20206 5.55452 7.90317C5.9541 7.60428 6.52031 7.68591 6.8192 8.08549C7.02234 8.35706 7.28151 8.58177 7.57913 8.74437C7.87675 8.90697 8.20585 9.00367 8.54413 9.02789C8.8824 9.05212 9.22193 9.00331 9.53969 8.88478C9.85744 8.76625 10.146 8.58077 10.3858 8.34092L12.341 6.38564C12.7687 5.94014 13.0052 5.34495 12.9998 4.72724C12.9944 4.10712 12.7457 3.51393 12.3072 3.07542C11.8687 2.63691 11.2755 2.38818 10.6554 2.38279C10.0373 2.37742 9.44171 2.61425 8.99612 3.04244L7.87672 4.15532C7.52285 4.50714 6.95079 4.50547 6.59897 4.1516C6.24716 3.79773 6.24883 3.22566 6.6027 2.87385L7.73643 1.74684Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.6357 5.3681C5.19623 5.159 5.79517 5.0729 6.3919 5.11564C6.98863 5.15838 7.56919 5.32895 8.0942 5.61579C8.61921 5.90262 9.0764 6.29902 9.43474 6.77808C9.73363 7.17766 9.652 7.74388 9.25243 8.04277C8.85285 8.34165 8.28663 8.26003 7.98774 7.86045C7.7846 7.58888 7.52544 7.36417 7.22782 7.20157C6.9302 7.03896 6.60109 6.94227 6.26281 6.91804C5.92454 6.89382 5.58501 6.94262 5.26726 7.06115C4.9495 7.17969 4.66096 7.36517 4.42119 7.60502L2.46592 9.5603C2.03826 10.0058 1.80174 10.601 1.80711 11.2187C1.8125 11.8388 2.06123 12.432 2.49974 12.8705C2.93824 13.309 3.53144 13.5578 4.15155 13.5631C4.76927 13.5685 5.36447 13.332 5.80997 12.9043L6.92182 11.7925C7.27466 11.4396 7.84673 11.4396 8.19957 11.7925C8.55242 12.1453 8.55242 12.7174 8.19957 13.0702L7.08171 14.1881L7.07052 14.1991C6.28365 14.9591 5.22976 15.3796 4.13585 15.3701C3.04194 15.3606 1.99552 14.9218 1.22198 14.1483C0.448439 13.3747 0.00966353 12.3283 0.000157717 11.2344C-0.00934809 10.1405 0.411177 9.08661 1.17116 8.29974L1.18217 8.28854L3.14321 6.3275C3.14325 6.32746 3.14317 6.32754 3.14321 6.3275C3.56614 5.90444 4.07522 5.57717 4.6357 5.3681Z"
      fill="currentColor"
    />
  </svg>
);

export const mobileHomeSvg = () => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4302 12.7424C11.4335 12.7424 12.2502 13.5532 12.2502 14.5499V17.1132C12.2502 17.3274 12.4218 17.4991 12.6418 17.5041H14.2302C15.4818 17.5041 16.4993 16.4991 16.4993 15.2641V7.99405C16.4935 7.56905 16.291 7.16905 15.9435 6.90322L10.4493 2.52155C9.71185 1.93738 8.68018 1.93738 7.94018 2.52322L2.48352 6.90155C2.12268 7.17572 1.92018 7.57572 1.91602 8.00822V15.2641C1.91602 16.4991 2.93352 17.5041 4.18518 17.5041H5.78852C6.01435 17.5041 6.19768 17.3249 6.19768 17.1049C6.19768 17.0566 6.20351 17.0082 6.21351 16.9624V14.5499C6.21351 13.5591 7.02518 12.7491 8.02102 12.7424H10.4302ZM14.2302 18.7541H12.6268C11.7085 18.7324 11.0002 18.0116 11.0002 17.1132V14.5499C11.0002 14.2424 10.7443 13.9924 10.4302 13.9924H8.02518C7.71768 13.9941 7.46352 14.2449 7.46352 14.5499V17.1049C7.46352 17.1674 7.45518 17.2274 7.43768 17.2841C7.34768 18.1091 6.64268 18.7541 5.78852 18.7541H4.18518C2.24435 18.7541 0.666016 17.1882 0.666016 15.2641V8.00238C0.674349 7.17405 1.05602 6.41572 1.71518 5.91655L7.16101 1.54572C8.36018 0.595716 10.031 0.595716 11.2277 1.54405L16.7127 5.91905C17.3568 6.40988 17.7385 7.16655 17.7493 7.98488V15.2641C17.7493 17.1882 16.171 18.7541 14.2302 18.7541Z"
      fill="currentColor"
    />
  </svg>
);
export const menuBarsSvg = () => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.20768 9.83366C7.59852 9.83366 7.74935 10.9837 7.74935 13.3753C7.74935 14.5737 7.74935 15.4262 7.24602 16.0503C6.66685 16.7695 5.61268 16.917 4.20768 16.917C2.80268 16.917 1.74852 16.7695 1.16935 16.0503C0.666016 15.4262 0.666016 14.5745 0.666016 13.3962L1.29102 13.3753H0.666016C0.666016 10.9837 0.816849 9.83366 4.20768 9.83366ZM13.3743 9.83366C16.7652 9.83366 16.916 10.9837 16.916 13.3753C16.916 14.5737 16.916 15.4262 16.4127 16.0503C15.8335 16.7695 14.7793 16.917 13.3743 16.917C11.9693 16.917 10.9152 16.7695 10.336 16.0503C9.83268 15.4262 9.83268 14.5745 9.83268 13.3962L10.4577 13.3753H9.83268C9.83268 10.9837 9.98352 9.83366 13.3743 9.83366ZM4.37948 11.084L4.20768 11.0837C2.03354 11.0837 1.92204 11.2397 1.91632 13.0645L1.91667 13.7755C1.92062 14.5013 1.94828 15.0256 2.14185 15.267C2.36268 15.5403 3.01852 15.667 4.20768 15.667C5.39685 15.667 6.05268 15.5395 6.27352 15.2662C6.49935 14.9853 6.49935 14.3187 6.49935 13.3953C6.49935 11.3118 6.49935 11.0938 4.37948 11.084ZM13.5461 11.084L13.3743 11.0837C11.2002 11.0837 11.0887 11.2397 11.083 13.0645L11.0833 13.7755C11.0873 14.5013 11.1149 15.0256 11.3085 15.267C11.5293 15.5403 12.1852 15.667 13.3743 15.667C14.5635 15.667 15.2193 15.5395 15.4402 15.2662C15.666 14.9853 15.666 14.3187 15.666 13.3953C15.666 11.3118 15.666 11.0938 13.5461 11.084ZM4.20768 0.666992C7.59852 0.666992 7.74935 1.81699 7.74935 4.20866C7.74935 5.40699 7.74935 6.25949 7.24602 6.88366C6.66685 7.60283 5.61268 7.75033 4.20768 7.75033C2.80268 7.75033 1.74852 7.60283 1.16935 6.88366C0.666016 6.25949 0.666016 5.40783 0.666016 4.22949L1.29102 4.20866H0.666016C0.666016 1.81699 0.816849 0.666992 4.20768 0.666992ZM13.3743 0.666992C16.7652 0.666992 16.916 1.81699 16.916 4.20866C16.916 5.40699 16.916 6.25949 16.4127 6.88366C15.8335 7.60283 14.7793 7.75033 13.3743 7.75033C11.9693 7.75033 10.9152 7.60283 10.336 6.88366C9.83268 6.25949 9.83268 5.40783 9.83268 4.22949L10.4577 4.20866H9.83268C9.83268 1.81699 9.98352 0.666992 13.3743 0.666992ZM4.37948 1.91736L4.20768 1.91699C2.03354 1.91699 1.92204 2.073 1.91632 3.89787L1.91667 4.60881C1.92062 5.33461 1.94828 5.8589 2.14185 6.10033C2.36268 6.37366 3.01852 6.50033 4.20768 6.50033C5.39685 6.50033 6.05268 6.37283 6.27352 6.09949C6.49935 5.81866 6.49935 5.15199 6.49935 4.22866C6.49935 2.14515 6.49935 1.92717 4.37948 1.91736ZM13.5461 1.91736L13.3743 1.91699C11.2002 1.91699 11.0887 2.073 11.083 3.89787L11.0833 4.60881C11.0873 5.33461 11.1149 5.8589 11.3085 6.10033C11.5293 6.37366 12.1852 6.50033 13.3743 6.50033C14.5635 6.50033 15.2193 6.37283 15.4402 6.09949C15.666 5.81866 15.666 5.15199 15.666 4.22866C15.666 2.14515 15.666 1.92717 13.5461 1.91736Z"
      fill="currentColor"
    />
  </svg>
);

export const fbColoredSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16 8.00002C16 3.58174 12.4183 2.00272e-05 8 2.00272e-05C3.58172 2.00272e-05 0 3.58174 0 8.00002C0 11.9931 2.92548 15.3027 6.75 15.9028V10.3125H4.71875V8.00002H6.75V6.23752C6.75 4.23252 7.94434 3.12502 9.77172 3.12502C10.647 3.12502 11.5625 3.28127 11.5625 3.28127V5.25002H10.5537C9.55992 5.25002 9.25 5.86669 9.25 6.49935V8.00002H11.4688L11.1141 10.3125H9.25V15.9028C13.0745 15.3027 16 11.9931 16 8.00002Z"
      fill="#1877F2"
    />
  </svg>
);
export const googleSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9999 9.20008C17.9999 8.46009 17.9386 7.92009 17.806 7.36011H9.18359V10.7H14.2448C14.1428 11.5301 13.5917 12.7801 12.3672 13.62L12.3501 13.7318L15.0763 15.8016L15.2652 15.82C16.9999 14.25 17.9999 11.94 17.9999 9.20008Z"
      fill="#4285F4"
    />
    <path
      d="M9.18358 18C11.6631 18 13.7447 17.1999 15.2652 15.82L12.3672 13.62C11.5917 14.1499 10.5509 14.5199 9.18358 14.5199C6.75503 14.5199 4.69382 12.95 3.95906 10.78L3.85136 10.789L1.01656 12.939L0.979492 13.04C2.48968 15.9799 5.59172 18 9.18358 18Z"
      fill="#34A853"
    />
    <path
      d="M3.95913 10.7803C3.76526 10.2203 3.65306 9.62025 3.65306 9.00028C3.65306 8.38025 3.76526 7.78028 3.94893 7.22029L3.9438 7.10103L1.07348 4.9165L0.979566 4.96028C0.357146 6.18028 0 7.5503 0 9.00028C0 10.4503 0.357146 11.8202 0.979566 13.0402L3.95913 10.7803Z"
      fill="#FBBC05"
    />
    <path
      d="M9.18358 3.47995C10.908 3.47995 12.0713 4.20994 12.7346 4.81997L15.3264 2.33998C13.7346 0.889996 11.6631 0 9.18358 0C5.59172 0 2.48968 2.01997 0.979492 4.95992L3.94886 7.21993C4.69382 5.04995 6.75503 3.47995 9.18358 3.47995Z"
      fill="#EB4335"
    />
  </svg>
);

export const deleteSvg = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 3.75H2.33333H13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.33398 3.74992V2.41659C4.33398 2.06296 4.47446 1.72382 4.72451 1.47378C4.97456 1.22373 5.3137 1.08325 5.66732 1.08325H8.33398C8.68761 1.08325 9.02674 1.22373 9.27679 1.47378C9.52684 1.72382 9.66732 2.06296 9.66732 2.41659V3.74992M11.6673 3.74992V13.0833C11.6673 13.4369 11.5268 13.776 11.2768 14.0261C11.0267 14.2761 10.6876 14.4166 10.334 14.4166H3.66732C3.3137 14.4166 2.97456 14.2761 2.72451 14.0261C2.47446 13.776 2.33398 13.4369 2.33398 13.0833V3.74992H11.6673Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const deliveryIcon = () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.4945 9.24184C15.4975 9.09902 15.4584 8.95848 15.3823 8.83764C15.3151 8.70477 15.2094 8.59522 15.0791 8.52326L14.0686 7.96186V4.00963L7.1185 0.0798545C7.00835 0.0208379 6.88395 -0.00637558 6.75921 0.00125826H6.53465L6.42238 0.0910827C6.31344 0.161779 6.2337 0.26943 6.19781 0.394236V0.630023L6.4336 1.53948C6.56524 2.03834 6.7984 2.50467 7.1185 2.90929C7.18587 2.99912 7.27569 3.07771 7.35429 3.16753L7.75849 4.42506C7.89228 4.84181 8.11441 5.22478 8.40972 5.54785L6.27641 6.86152L0.898233 3.81875C0.785974 3.76665 0.662451 3.74349 0.53894 3.75139H0.325611L0.213329 3.82998C0.115498 3.89985 0.0411241 3.99771 0 4.11068V4.34647L0.235785 5.26716C0.369793 5.76512 0.602727 6.23098 0.92069 6.63696C0.997921 6.73487 1.0844 6.82511 1.17893 6.90643L1.56068 8.14151C1.72169 8.72533 2.04021 9.2536 2.48137 9.6685V15.0579C2.47802 15.2584 2.52842 15.4561 2.62734 15.6305C2.72631 15.8132 2.87401 15.9647 3.05399 16.0684L8.60059 19.1898C8.77717 19.2946 8.97912 19.349 9.18445 19.347C9.39358 19.351 9.59968 19.2966 9.77952 19.1898L14.9219 16.0684C15.0921 15.9657 15.2347 15.8231 15.3373 15.653C15.43 15.4761 15.48 15.28 15.4833 15.0804V9.4664C15.5008 9.39287 15.5046 9.31675 15.4945 9.24184ZM9.66725 5.49172C9.40261 5.35775 9.16713 5.17269 8.97442 4.94721C8.7817 4.72174 8.63557 4.46032 8.54445 4.17805L13.0356 6.74924V7.4566L9.66725 5.49172ZM13.1255 4.5598V5.68259L8.63428 3.16753C8.29553 2.97235 7.99805 2.71301 7.75849 2.40404C7.51604 2.09539 7.34019 1.73985 7.24201 1.35984V1.28124L13.1255 4.5598ZM9.10585 6.24399C9.13683 6.27026 9.17073 6.29286 9.2069 6.31135L14.4503 9.23062L12.5865 10.4545L7.87078 7.77099L7.21956 7.40046L9.10585 6.24399ZM9.21813 12.453L7.91568 11.712V8.84887L11.6658 10.9597L9.21813 12.453ZM3.51434 9.23062C2.98872 8.94884 2.58803 8.48003 2.39155 7.91695L6.97254 10.4545V11.1618L3.51434 9.23062ZM6.97254 12.2622V13.8228C6.8299 13.6221 6.72351 13.3979 6.65816 13.1604L6.48974 12.5429L4.24416 11.3078C4.04116 11.1834 3.86546 11.0191 3.72767 10.825C3.63283 10.6729 3.56449 10.5059 3.52557 10.331L6.97254 12.2622ZM6.08554 7.77099L6.97254 8.27624V9.39903L2.48137 6.88398C2.14262 6.68879 1.84515 6.42946 1.60559 6.12048C1.36314 5.81183 1.18728 5.45629 1.08911 5.07628V4.99769L6.08554 7.77099ZM3.48066 15.1365V11.8692C3.59094 11.9677 3.71138 12.0543 3.83995 12.1274L5.69256 13.1828L5.75992 13.4186C5.91812 13.9823 6.22897 14.4913 6.65816 14.8895L6.82658 15.0467C6.92165 15.1233 7.03305 15.1771 7.15219 15.2039H7.3992H7.53394C7.64737 15.1473 7.74411 15.0622 7.81464 14.9569L7.91568 14.7323V12.7899L8.74656 13.2614V18.168L3.48066 15.1365ZM9.66725 18.1344V13.2727L12.1262 11.7794V16.686L9.66725 18.1344ZM14.4728 15.2263L13.0581 16.0797V11.2067L14.5738 10.2748V15.0804L14.4728 15.2263Z"
      fill="black"
    />
  </svg>
);
export const strangeCircle = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 17.3135C13.4183 17.3135 17 13.7318 17 9.31348C17 4.8952 13.4183 1.31348 9 1.31348C4.58172 1.31348 1 4.8952 1 9.31348C1 13.7318 4.58172 17.3135 9 17.3135Z"
      stroke="black"
      strokeMiterlimit="10"
    />
    <path
      d="M1 9.31348H3.38956"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M2.13672 5.18921L3.73096 5.98813"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M5.35156 2.18433L6.14688 3.77857"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9 17.3136V14.9241"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M4.875 16.1761L5.67392 14.5854"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M1.87109 12.9662L3.46534 12.1672"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M15.8602 13.4376L14.2695 12.6387"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12.6544 16.4426L11.8555 14.8484"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9.05859 2.47586L10.1418 1.39624"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9 5.20385L12.2173 1.98657"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M8.98828 7.88439L13.8898 2.98291"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M10.2266 9.3134L15.236 4.30396"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M12.8984 9.31326L16.2381 5.97363"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M15.5703 9.31329L16.8946 7.98535"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M9 1.31348V9.23071C8.99999 9.24094 9.00206 9.25107 9.00608 9.26048C9.01011 9.2699 9.01599 9.27839 9.02339 9.28546C9.0308 9.29253 9.03957 9.29801 9.04916 9.30159C9.05875 9.30517 9.06896 9.30677 9.07918 9.30628H16.9964"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
  </svg>
);
export const pointSvg = () => (
  <svg
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.6538 9.52056C13.5559 9.27762 13.4099 9.05694 13.2247 8.87172C13.0395 8.6865 12.8188 8.54055 12.5759 8.44261C12.0859 8.2404 11.5358 8.2404 11.0459 8.44261L10.8024 8.5817C10.7937 8.33905 10.7428 8.09977 10.6518 7.87466C10.5545 7.62849 10.4041 7.40684 10.2113 7.22557C10.0271 7.03624 9.80622 6.88638 9.56222 6.78511C9.32227 6.68969 9.067 6.63863 8.80881 6.63443C8.44999 6.6446 8.09938 6.7442 7.78881 6.9242V5.02329C7.79165 4.76065 7.74036 4.50024 7.63813 4.25829C7.53814 4.01642 7.39253 3.79605 7.20926 3.6092C7.02543 3.42224 6.80427 3.27611 6.56018 3.18034C6.31897 3.07445 6.05859 3.01922 5.79517 3.01807C5.53378 3.01804 5.27503 3.07033 5.03417 3.17185C4.7933 3.27338 4.57518 3.42208 4.39267 3.6092C4.20233 3.79259 4.05232 4.01366 3.95222 4.25829C3.85 4.50024 3.79871 4.76065 3.80154 5.02329V10.7144L3.65086 10.4478C3.39733 10.0019 2.98252 9.67001 2.49177 9.52056C2.23825 9.45108 1.97344 9.43272 1.71276 9.46655C1.45209 9.50037 1.20074 9.58572 0.973362 9.71761C0.526063 9.97249 0.190941 10.3862 0.0345015 10.8767C-0.0115005 11.1335 -0.0115005 11.3965 0.0345015 11.6533C0.0666678 11.9157 0.153532 12.1684 0.289494 12.3951L2.21359 15.7101C2.25692 15.7852 2.31952 15.8473 2.39492 15.8901C2.47031 15.9329 2.55577 15.9548 2.64245 15.9535C2.73105 15.9567 2.81893 15.9367 2.89745 15.8956C2.95382 15.8621 3.00305 15.8179 3.04231 15.7654C3.08156 15.7129 3.11008 15.6532 3.12623 15.5897C3.14238 15.5262 3.14584 15.4601 3.13642 15.3952C3.12699 15.3304 3.10487 15.268 3.07131 15.2117L1.14723 11.8967C1.07739 11.7842 1.03381 11.6574 1.01973 11.5258C0.990748 11.396 0.990748 11.2615 1.01973 11.1317C1.05401 11.0054 1.11312 10.8872 1.19359 10.784C1.27774 10.6782 1.37972 10.588 1.49495 10.5174C1.7284 10.3888 2.00255 10.3556 2.25995 10.4247C2.38868 10.4593 2.50925 10.5192 2.6147 10.6008C2.72014 10.6823 2.80837 10.784 2.87427 10.8999L3.7204 12.6037V12.7197L4.06813 12.9978H4.497L4.78677 12.6617V5.02329C4.78521 4.89251 4.80882 4.76265 4.85631 4.64079C4.91183 4.518 4.98613 4.40459 5.07654 4.30466C5.17491 4.21224 5.28867 4.13771 5.41268 4.08443C5.53084 4.03811 5.65668 4.01452 5.78359 4.01488C5.91548 4.01371 6.04603 4.0414 6.16608 4.09602C6.28925 4.14446 6.40012 4.21968 6.49063 4.31625C6.58948 4.40479 6.66509 4.51623 6.71085 4.64079C6.76781 4.76007 6.79562 4.89117 6.79199 5.02329V11.9778C6.79199 12.11 6.8445 12.2368 6.93797 12.3303C7.03144 12.4237 7.15821 12.4762 7.2904 12.4762C7.35532 12.4763 7.41958 12.4633 7.47941 12.4381C7.53925 12.4129 7.59343 12.376 7.63879 12.3296C7.68415 12.2831 7.71977 12.2281 7.74354 12.1677C7.76731 12.1073 7.77876 12.0427 7.77722 11.9778V8.62806C7.77721 8.49466 7.80367 8.36257 7.85507 8.23947C7.90647 8.11636 7.98179 8.00467 8.07666 7.91088C8.17153 7.81709 8.28407 7.74305 8.40776 7.69306C8.53145 7.64307 8.66382 7.61812 8.79722 7.61966C8.92773 7.62114 9.05705 7.64465 9.17972 7.6892C9.2989 7.74493 9.40845 7.81927 9.50427 7.90943C9.59821 8.00215 9.67303 8.11242 9.72449 8.23397C9.7743 8.3596 9.80176 8.49297 9.80562 8.62806V10.2856C9.80675 10.3049 9.80675 10.3242 9.80562 10.3435V12.3024C9.80562 12.4346 9.85814 12.5613 9.95161 12.6548C10.0451 12.7483 10.1718 12.8008 10.304 12.8008C10.3695 12.8008 10.4343 12.7879 10.4948 12.7628C10.5552 12.7378 10.6102 12.7011 10.6565 12.6548C10.7027 12.6085 10.7395 12.5536 10.7645 12.4931C10.7896 12.4326 10.8024 12.3678 10.8024 12.3024V10.2856C10.8064 10.1629 10.8299 10.0416 10.872 9.92625C10.9247 9.80538 10.9994 9.69533 11.0922 9.6017C11.1845 9.50427 11.2947 9.42556 11.4168 9.36988C11.6662 9.27112 11.9439 9.27112 12.1934 9.36988C12.3158 9.41424 12.4267 9.48554 12.5179 9.57852C12.6122 9.67541 12.6869 9.78953 12.7381 9.91465C12.7883 10.0361 12.8158 10.1658 12.8193 10.2972V12.3719C12.8973 13.3653 12.6132 14.3535 12.0195 15.1537C11.9732 15.1991 11.9365 15.2532 11.9114 15.3129C11.8863 15.3726 11.8734 15.4367 11.8734 15.5015C11.8734 15.5662 11.8863 15.6303 11.9114 15.6901C11.9365 15.7498 11.9732 15.8039 12.0195 15.8492C12.0631 15.898 12.1168 15.9367 12.1768 15.9627C12.2368 15.9888 12.3018 16.0014 12.3672 15.9999C12.4315 16.0008 12.4953 15.989 12.555 15.9651C12.6147 15.9412 12.669 15.9058 12.7149 15.8608C13.477 14.8677 13.8556 13.6331 13.7813 12.3835V10.2856C13.7899 10.0246 13.7466 9.7646 13.6538 9.52056Z"
      fill="black"
    />
    <path
      d="M1.92614 4.81465C1.99106 4.81467 2.05533 4.8017 2.11516 4.77651C2.17499 4.75133 2.22918 4.71443 2.27454 4.66799C2.3199 4.62155 2.35551 4.5665 2.37928 4.5061C2.40306 4.44569 2.4145 4.38114 2.41296 4.31624C2.41403 3.87398 2.50267 3.43631 2.67375 3.02849C2.84484 2.62066 3.09499 2.25075 3.40978 1.9401C4.05467 1.33375 4.90653 0.996175 5.79171 0.996175C6.67689 0.996175 7.52875 1.33375 8.17364 1.9401C8.80196 2.57162 9.15596 3.4254 9.15886 4.31624C9.15886 4.44842 9.21138 4.5752 9.30485 4.66867C9.39832 4.76214 9.52509 4.81465 9.65727 4.81465C9.78946 4.81465 9.91623 4.76214 10.0097 4.66867C10.1032 4.5752 10.1557 4.44842 10.1557 4.31624C10.1527 3.16083 9.69461 2.05312 8.88068 1.23306C8.04708 0.441392 6.94133 0 5.79171 0C4.64208 0 3.53634 0.441392 2.70273 1.23306C1.88881 2.05312 1.43074 3.16083 1.42773 4.31624C1.42773 4.44842 1.48025 4.5752 1.57372 4.66867C1.66719 4.76214 1.79396 4.81465 1.92614 4.81465Z"
      fill="black"
    />
  </svg>
);
export const giftFooterSvg = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.9311 8.63181C15.8734 8.43453 15.777 8.25067 15.6476 8.09093C15.5181 7.93118 15.3582 7.79874 15.177 7.70129L13.5928 6.84674C14.086 6.41601 14.4052 5.82043 14.4905 5.17154C14.5759 4.52264 14.4215 3.86494 14.0563 3.32159C13.6911 2.77824 13.14 2.3865 12.5065 2.21975C11.8729 2.053 11.2003 2.12267 10.6144 2.4157C10.5956 2.25099 10.5638 2.08802 10.5193 1.92829C10.3663 1.41709 10.0651 0.962582 9.65389 0.622046C9.24266 0.281509 8.73969 0.0701711 8.20843 0.0146655C7.67716 -0.0408401 7.14139 0.0619738 6.66851 0.310141C6.19564 0.558308 5.80686 0.940723 5.55119 1.40922C5.39264 1.69951 5.2915 2.01759 5.25333 2.34607L3.66909 1.49151C3.48813 1.39366 3.28966 1.33241 3.08498 1.31127C2.8803 1.29012 2.67344 1.30951 2.47627 1.3683C2.27909 1.4271 2.09545 1.52415 1.93586 1.65391C1.77627 1.78366 1.64387 1.94359 1.54622 2.12452L0.101374 4.78313C0.0301139 4.91737 0.0142294 5.07411 0.0570497 5.21991C0.100868 5.36282 0.198572 5.48312 0.329535 5.5554L5.31672 8.25201H0.563999C0.41442 8.25201 0.270961 8.31136 0.165193 8.41701C0.0594241 8.52267 0 8.66597 0 8.81538V14.4744C-1.73107e-06 14.6753 0.0397002 14.8742 0.116846 15.0597C0.193991 15.2452 0.307065 15.4137 0.449552 15.5554C0.592038 15.6972 0.761158 15.8094 0.94718 15.8857C1.1332 15.962 1.33245 16.0008 1.53353 16H12.8387C13.2437 16 13.6322 15.8393 13.9186 15.5532C14.205 15.2671 14.3659 14.879 14.3659 14.4744V12.4995L15.8107 9.84085C15.9098 9.6573 15.9716 9.45592 15.9923 9.24838C16.0129 9.04084 15.9921 8.83127 15.9311 8.63181ZM12.6739 3.26393C13.0812 3.485 13.3844 3.85799 13.5173 4.30151C13.6503 4.74504 13.6022 5.22309 13.3837 5.63137C13.2297 5.89271 13.0116 6.11056 12.75 6.26437C12.7197 6.2841 12.6921 6.30748 12.6676 6.334L9.8223 4.7958L10.2849 3.94124C10.3965 3.73939 10.5471 3.56162 10.7279 3.41819C10.9087 3.27475 11.1161 3.16849 11.3382 3.10552C11.5602 3.04255 11.7926 3.02414 12.0219 3.05132C12.2512 3.07851 12.4728 3.15077 12.6739 3.26393ZM6.17854 2.68156C6.17705 2.39195 6.24897 2.10667 6.38763 1.85233C6.55134 1.54685 6.80231 1.29689 7.10859 1.13424C7.41487 0.971584 7.76264 0.903583 8.10771 0.938867C8.45278 0.97415 8.77956 1.11112 9.0465 1.33239C9.31343 1.55365 9.5085 1.84921 9.60686 2.18148C9.67279 2.40126 9.69438 2.63192 9.67045 2.8601C9.64652 3.08828 9.57749 3.30945 9.46739 3.5108L9.0048 4.35902L6.14682 2.81449C6.16624 2.77276 6.17704 2.72755 6.17854 2.68156ZM2.37636 2.56129C2.45763 2.42098 2.58968 2.31716 2.74531 2.27122C2.90094 2.22529 3.06829 2.24075 3.21285 2.31442L8.54856 5.20092L6.98969 8.06843L1.11531 4.90341L2.37636 2.56129ZM1.52719 15.0378C1.37366 15.0378 1.22636 14.9773 1.11721 14.8695C1.00805 14.7616 0.94587 14.6151 0.944202 14.4618V9.18885H6.69187V15.0378H1.52719ZM12.8324 15.0378H7.64242V9.49902L13.409 12.6197V14.4618C13.409 14.6135 13.3491 14.759 13.2423 14.8669C13.1356 14.9747 12.9905 15.0361 12.8387 15.0378H12.8324ZM14.9679 9.34077L13.7005 11.6702L7.81979 8.50521L9.37874 5.6377L14.7144 8.5242C14.8574 8.60359 14.9641 8.73514 15.0122 8.89134C15.0637 9.05043 15.05 9.22337 14.9743 9.37242L14.9679 9.34077Z"
      fill="black"
    />
  </svg>
);
export const pieIcon = () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.353 8.52145C12.653 8.52145 12.8137 8.75062 12.7848 8.94423C12.3408 11.9205 9.77838 14.1979 6.67648 14.1979C3.26093 14.1979 0.5 11.437 0.5 8.02145C0.5 4.91956 2.77749 2.35714 5.75369 1.91312C5.9473 1.88424 6.17648 2.0449 6.17648 2.34497V8.01145C6.17648 8.29308 6.40478 8.52145 6.68647 8.52145H12.353Z"
      stroke="black"
    />
    <path
      d="M14.4578 5.54651C14.4881 5.73126 14.3352 5.96112 14.0322 5.96112H9.14033C8.86419 5.96112 8.64034 5.73726 8.64034 5.46112V0.999999C8.64034 0.702588 8.86894 0.535094 9.07054 0.562402C11.8614 0.940451 14.0368 2.98715 14.4578 5.54651Z"
      stroke="black"
    />
  </svg>
);
export const phoneFooterSvg = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3046 12.6088C13.0369 12.289 12.6636 12.0756 12.2521 12.0074L10.2475 11.7067C9.97853 11.6646 9.70329 11.6886 9.44569 11.7769C9.19252 11.8538 8.96199 11.9915 8.77415 12.1778C8.65277 12.2891 8.49739 12.3562 8.33314 12.3683C8.15497 12.3801 7.97811 12.3306 7.83199 12.2279C6.71624 11.565 5.78282 10.635 5.11575 9.52172C5.03652 9.38187 5.00486 9.22006 5.02554 9.06066C5.04384 8.90492 5.11453 8.76001 5.226 8.64972C5.4169 8.46975 5.56134 8.24621 5.64697 7.99822C5.73523 7.74063 5.75932 7.46539 5.71713 7.19638L5.41644 5.19178C5.33545 4.80153 5.12751 4.44908 4.82509 4.18948C4.52059 3.89237 4.11748 3.71757 3.69248 3.69835H1.76806C1.53502 3.68827 1.30243 3.72673 1.08503 3.81127C0.867635 3.89582 0.670172 4.02461 0.505165 4.18948C0.184772 4.51187 0.00465798 4.94774 0.00401391 5.40226C-0.0381038 7.01234 0.251614 8.61386 0.855135 10.1071C1.45866 11.6004 2.36306 12.9535 3.51207 14.0822C5.77256 16.2212 8.74973 17.4399 11.8612 17.5H12.1419C12.5901 17.4779 13.0115 17.2798 13.3146 16.9488C13.4675 16.789 13.5871 16.6003 13.6662 16.3938C13.7454 16.1873 13.7826 15.9671 13.7756 15.746V13.7414C13.7628 13.3189 13.5951 12.9158 13.3046 12.6088ZM12.5328 16.2672C12.4084 16.4035 12.2359 16.4862 12.0517 16.4977C9.11314 16.5084 6.28385 15.3846 4.15354 13.3605C3.10664 12.3246 2.28701 11.082 1.74687 9.71177C1.20674 8.34158 0.957939 6.87391 1.01634 5.40226C1.01903 5.21132 1.09428 5.02856 1.22682 4.89109C1.29299 4.82624 1.37133 4.77514 1.45735 4.74074C1.54336 4.70633 1.63534 4.6893 1.72797 4.69063H3.65239C3.83167 4.69416 4.00459 4.75768 4.14352 4.87104C4.27387 4.99014 4.36184 5.14848 4.3941 5.32208L4.69479 7.32668C4.72502 7.43826 4.72502 7.55588 4.69479 7.66746C4.66171 7.7735 4.60321 7.86984 4.52439 7.94811C4.25083 8.21618 4.07748 8.56996 4.03327 8.95041C3.99036 9.31465 4.06405 9.68311 4.24375 10.0028C4.97804 11.2626 6.0106 12.3227 7.25065 13.0899C7.57957 13.3071 7.96968 13.4125 8.36321 13.3906C8.76336 13.3619 9.14012 13.1913 9.42565 12.9095C9.50223 12.8286 9.59916 12.7697 9.70629 12.7391C9.81788 12.7089 9.93549 12.7089 10.0471 12.7391L12.0517 13.0398C12.2289 13.07 12.391 13.1581 12.5127 13.2904C12.6247 13.4262 12.6882 13.5955 12.6932 13.7715V15.7761C12.7051 15.9544 12.6477 16.1304 12.5328 16.2672Z"
      fill="black"
    />
    <path
      d="M7.90267 7.20622C8.4767 7.38748 8.9973 7.7072 9.41856 8.1372C9.83982 8.5672 10.1488 9.09426 10.3182 9.67189C10.3518 9.7669 10.4144 9.84897 10.4971 9.90652C10.5798 9.96406 10.6785 9.99418 10.7793 9.99262C10.839 10.0022 10.8999 10.0022 10.9597 9.99262C11.0215 9.97036 11.0781 9.93594 11.1264 9.8914C11.1746 9.84686 11.2134 9.79309 11.2405 9.73329C11.2676 9.67348 11.2825 9.60885 11.2841 9.54321C11.2858 9.47758 11.2743 9.41227 11.2504 9.35115C11.0219 8.61539 10.615 7.94758 10.0658 7.4072C9.51672 6.86683 8.84246 6.47067 8.10313 6.25404C8.03864 6.24086 7.97218 6.24052 7.90755 6.25304C7.84292 6.26555 7.78139 6.29068 7.72647 6.32698C7.67156 6.36328 7.62433 6.41004 7.58749 6.4646C7.55065 6.51915 7.52493 6.58043 7.51178 6.64494C7.49608 6.77026 7.52733 6.89695 7.59951 7.00059C7.67169 7.10423 7.77969 7.17749 7.90267 7.20622Z"
      fill="black"
    />
    <path
      d="M9.13394 3.34753C9.06939 3.3406 9.0041 3.34654 8.94185 3.36501C8.87961 3.38348 8.82164 3.4141 8.77131 3.45511C8.72098 3.49613 8.67927 3.54671 8.64862 3.60394C8.61796 3.66118 8.59895 3.72392 8.5927 3.78854C8.57861 3.92003 8.61706 4.05175 8.69966 4.15501C8.78227 4.25827 8.90234 4.32469 9.03371 4.33981C9.14396 4.33981 11.77 4.70064 13.1832 8.57954C13.2183 8.6764 13.2823 8.76012 13.3666 8.8193C13.4509 8.87849 13.5513 8.91026 13.6543 8.9103C13.7106 8.92066 13.7684 8.92066 13.8247 8.9103C13.8874 8.88906 13.9451 8.85537 13.9944 8.81127C14.0437 8.76716 14.0836 8.71354 14.1117 8.65363C14.1398 8.59372 14.1555 8.52875 14.1578 8.46263C14.1602 8.3965 14.1492 8.33059 14.1254 8.26883C12.5317 3.73843 9.27426 3.35755 9.13394 3.34753Z"
      fill="black"
    />
    <path
      d="M16.9745 7.19633C14.6993 0.841737 10.3493 0.510978 10.1689 0.500955C10.1031 0.496885 10.0371 0.505854 9.9747 0.527346C9.91233 0.548837 9.85482 0.58243 9.80547 0.626196C9.75612 0.669962 9.71589 0.723041 9.6871 0.782389C9.6583 0.841736 9.64151 0.906184 9.63767 0.972036C9.6336 1.03787 9.64257 1.10387 9.66406 1.16623C9.68555 1.2286 9.71915 1.28611 9.76292 1.33546C9.80668 1.38481 9.85976 1.42504 9.91911 1.45383C9.97846 1.48263 10.0429 1.49942 10.1088 1.50326C10.2591 1.50326 13.9877 1.84404 16.0223 7.51707C16.0579 7.61555 16.1235 7.70042 16.2097 7.75974C16.296 7.81906 16.3987 7.84987 16.5034 7.84783C16.5565 7.85741 16.6108 7.85741 16.6638 7.84783C16.7277 7.82652 16.7867 7.79253 16.8372 7.74791C16.8877 7.70329 16.9286 7.64895 16.9577 7.58813C16.9867 7.52731 17.0031 7.46127 17.006 7.39395C17.0089 7.32663 16.9982 7.25942 16.9745 7.19633Z"
      fill="black"
    />
  </svg>
);
export const mailFooterSvg = () => (
  <svg
    width="16"
    height="12"
    viewBox="0 0 16 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4672 0.351562H2.54844C1.8818 0.353901 1.24259 0.617202 0.767715 1.08507C0.292839 1.55294 0.0200628 2.18816 0.0078125 2.85469V9.09844C0.00780794 9.77312 0.275181 10.4203 0.751373 10.8983C1.22756 11.3762 1.87376 11.646 2.54844 11.6484H12.4672C13.1419 11.646 13.7881 11.3762 14.2643 10.8983C14.7404 10.4203 15.0078 9.77312 15.0078 9.09844V2.85469C14.9956 2.18816 14.7228 1.55294 14.2479 1.08507C13.773 0.617202 13.1338 0.353901 12.4672 0.351562ZM9.98281 6.19219L13.9484 2.22656C14.0275 2.42007 14.0689 2.6269 14.0703 2.83594V9.07969C14.0705 9.26886 14.0355 9.45641 13.9672 9.63281L9.98281 6.19219ZM12.4672 1.28906C12.7814 1.2903 13.0881 1.38493 13.3484 1.56094L9.01719 5.83594L8.93281 5.89219L8.24844 6.56719C8.07736 6.71749 7.85741 6.80038 7.62969 6.80038C7.40196 6.80038 7.18202 6.71749 7.01094 6.56719L1.68594 1.50469C1.94697 1.35197 2.24625 1.27715 2.54844 1.28906H12.4672ZM1.05781 9.65156C0.989498 9.47516 0.95453 9.28761 0.954688 9.09844V2.85469C0.946985 2.64054 0.982043 2.42701 1.05781 2.22656L5.08906 6.11719L1.05781 9.65156ZM2.55781 10.7109C2.22106 10.7059 1.89392 10.5979 1.62031 10.4016L5.79219 6.76406L6.34531 7.29844C6.68377 7.63933 7.14015 7.83732 7.62031 7.85156C8.09528 7.84739 8.55097 7.6631 8.89531 7.33594L9.33594 6.89531L13.4047 10.4484C13.1328 10.6482 12.8046 10.7565 12.4672 10.7578L2.55781 10.7109Z"
      fill="black"
    />
  </svg>
);
export const clearEmail = () => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 1.25L1.5 8.75"
      stroke="#C4C9D7"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M9 8.75L1.5 1.25"
      stroke="#C4C9D7"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export const instaFooter = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2978 11.2762C14.2978 12.9989 12.9604 14.3962 11.3166 14.3962H5.20117C3.55234 14.3962 2.2149 12.9989 2.2149 11.2762V4.8922C2.2149 3.1642 3.55234 1.7722 5.20117 1.7722H11.3166C12.9604 1.7722 14.2978 3.1642 14.2978 4.8922V11.2762ZM11.3166 0.182869H5.20117C2.71517 0.182869 0.693695 2.28953 0.693695 4.8922V11.2762C0.693695 13.8682 2.71517 15.9855 5.20117 15.9855H11.3166C13.7975 15.9855 15.819 13.8682 15.819 11.2762V4.8922C15.819 2.28953 13.7975 0.182869 11.3166 0.182869Z"
      fill="black"
    />
    <path
      d="M8.25867 10.579C6.93655 10.579 5.86966 9.46431 5.86966 8.08298C5.86966 6.70165 6.93655 5.58165 8.25867 5.58165C9.57569 5.58165 10.6477 6.70165 10.6477 8.08298C10.6477 9.46431 9.57569 10.579 8.25867 10.579ZM8.25867 3.99765C6.10448 3.99765 4.34845 5.82698 4.34845 8.08298C4.34845 10.339 6.10448 12.1736 8.25867 12.1736C10.4129 12.1736 12.1689 10.339 12.1689 8.08298C12.1689 5.82698 10.4129 3.99765 8.25867 3.99765Z"
      fill="black"
    />
    <path
      d="M12.1769 3.04713C12.6977 3.04713 13.1164 3.48456 13.1164 4.02867C13.1164 4.56746 12.6977 5.00488 12.1769 5.00488C11.6612 5.00488 11.2375 4.56746 11.2375 4.02867C11.2375 3.48456 11.6612 3.04713 12.1769 3.04713Z"
      fill="black"
    />
  </svg>
);

export const tiktokSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="512px"
    height="512px"
    viewBox="0 0 512 512"
    id="icons"
  >
    <path
      fill="currentColor"
      d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23,0,.47-.05.71,0,.06,0,.12,0,.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z"
    />
  </svg>
);
